/**
 * Action types for the Reporting → Inventory slice.
 *
 * Hits the existing `/inventory` aggregate endpoint and stores the full
 * response. Individual Reporting widgets read their fields via selectors.
 */

export const FETCH_INVENTORY_REPORT = 'FETCH_INVENTORY_REPORT';
export const FETCH_INVENTORY_REPORT_SUCCESS = 'FETCH_INVENTORY_REPORT_SUCCESS';
export const FETCH_INVENTORY_REPORT_FAIL = 'FETCH_INVENTORY_REPORT_FAIL';
